import React, { Component } from 'react'

import {
  Redirect,
  Switch
} from 'react-router-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { headTitleTag } from '../../helpers/functions'

import { CurrentStepSetAction } from '../../actions/action'
import CONSTANTS from '../../constants.js'

import fetchApiData from '../apiHandlers/fetchApiData'
import ReactDOM from 'react-dom'

import BodyClassName from 'react-body-classname'
import DealerBlock from '../DealerBlock/DealerBlock'
import DealerBlockLoader from '../DealerBlock/dealerBlockLoader'
import HappyHoureTitle from '../Titles/HappyHoureTitle'
import ShowMoreButton from '../buttons/showMoreButton'

import './pagemapsolo.css'

const google = window.google

const mapStateToProps = state => state
const mapDispatchToProps = { CurrentStepSetAction }

class PageSolo extends Component {
  constructor(props) {
    super(props)
    this.getDistanceBetweenPlaces = this.getDistanceBetweenPlaces.bind(this)
    this.showMore = this.showMore.bind(this)
    this.dealerIsHover = this.dealerIsHover.bind(this)
    this.state = {
      data: [],
      isLoading: false,
      selectedData: [],
      errorRedirect: false,
      pagination: 1,
      stickyMap: null,
      currentDealerData: [],
      map: {
        lat: Number(window.siteConfig.defaultCountryGeo.lat),
        lng: Number(window.siteConfig.defaultCountryGeo.lng)
      }
    }
    this._isMounted = false

  }

  componentDidMount() {
    this.props.CurrentStepSetAction(2)
    this.setState({ isLoading: true })
    this._isMounted = true
    const listDealers = new fetchApiData()
    listDealers.getListDealers().then(
      data => {
        if (this._isMounted) {
          this.setState({
            isLoading: false,
            data: data.d

          })

          this.setState({
            selectedData: Object.values(this.getDistanceBetweenPlaces(this.props)).slice(0, this.state.pagination)
          })
          if (!Object.values(this.state.currentDealerData).length) { this.setState({ errorRedirect: true }) }
        }
      })
      .catch(error => {
        this.setState({
          error: true,
          isLoading: false
        })
        console.error('fail', error)
      })

    // GA Start
    window.dataLayer.push({
      brand: window.siteConfig.brand,
      virtualPageURL: '/dealer-locator/solo-dealer',
      pageName: window.siteConfig.pageName,
      language: window.siteConfig.language,
      country: window.siteConfig.currentCountry,
      siteTypeLevel1: window.siteConfig.siteTypeLevel1,
      siteTypeLevel2: 'appointement',
      siteOwner: 'central',
      siteTarget: 'B2C',
      siteFamily: 'after-sales',
      pageCategory: 'dealer locator page'
    })

    // GA Ends
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  componentWillReceiveProps(nextProps) {

    this.setState({
      selectedData: Object.values(this.getDistanceBetweenPlaces(nextProps)).slice(0, this.state.pagination)
    })
  }

  getDistanceBetweenPlaces(urlProps = this.props) {
    console.log(urlProps)
    const IdDealer = urlProps.match.params.iddealer
    let dealers = Object.assign({}, this.state.data)
    let dealerKey = -1
    dealers = Object.values(dealers).map(function (dealer, key) {
      if (dealer.GeoId === IdDealer) {
        dealerKey = key
      }

      return dealer
    })
    if (dealers.length > 0 && dealerKey > -1) {
      this.setState({
        map: {
          lat: Number(dealers[dealerKey].Latitude),
          lng: Number(dealers[dealerKey].Longitude)
        },
        currentDealerData: dealers[dealerKey], pagination: 1
      })
    } else {
      this.setState({ currentDealerData: [], pagination: 0 })
    }

    dealers = Object.values(dealers).map(function (dealer, key) {
      dealer.IsHover = false
      const currentAdress = new google.maps.LatLng(this.state.map.lat, this.state.map.lng)
      const dealerLocation = new google.maps.LatLng(Number(dealer.Latitude), Number(dealer.Longitude))
      dealer.Distance = (google.maps.geometry.spherical.computeDistanceBetween(currentAdress, dealerLocation) / 1000).toFixed(2)
      return dealer
    }.bind(this))
    this.setState({
      data: dealers.sort(function (a, b) {
        return a.Distance - b.Distance
      })
    })
    return dealers.sort(function (a, b) {
      return a.Distance - b.Distance
    })
  }

  showMore() {
    this.setState({
      selectedData: this.state.data.slice(0, this.state.pagination + 10),
      pagination: this.state.pagination + 4
    })
  }

  dealerIsHover(id) {
    let dealers = Object.assign({}, this.state.selectedData)
    let selectedDealer = []
    dealers = Object.values(dealers).map(function (dealer) {
      if (dealer.DealerId === id) {
        dealer.IsHover = true
        selectedDealer = dealer
      }
      return dealer
    })

    this.setState({
      selectedData: dealers
    })
  }

  handleScrollToElement(idDealer) {
    const d = ReactDOM.findDOMNode(this.refs['id' + idDealer])
    d.focus()
    window.scrollTo(0, d.offsetTop)
  }

  render() {
    const SEO_TITLE = (window.siteConfig.v2solodealer != undefined ? window.siteConfig.v2solodealer.Title : '')
    const SEO_DESC = (window.siteConfig.v2solodealer != undefined ? window.siteConfig.v2solodealer.MetaDescription : '')
    const happyHoureMessage = (window.innerWidth <= 800 ? CONSTANTS.LABELS.multislots_happy_hours_mobile : CONSTANTS.LABELS.multislots_happy_hours_desktop)
    const isHappuHoureMessageEnabled = (happyHoureMessage.length > 2)

    return (
      <div className='content-wrapper container-small-content'>
        <BodyClassName className='page--soloDealer' />
        {
          (this.state.currentDealerData != null && !!Object.values(this.state.currentDealerData).length) &&
          headTitleTag(SEO_TITLE.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()).replace('[nom_garage]', this.state.currentDealerData.Name.toUpperCase()).replace('[nom_ville]', this.state.currentDealerData.City.toUpperCase()),
            SEO_DESC.replace('[nom_marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()).replace('[nom_garage]', this.state.currentDealerData.Name.toUpperCase()).replace('[nom_ville]', this.state.currentDealerData.City.toUpperCase()))

        }

        {((this.state.data.length < 1) && this.state.errorRedirect) &&
          <Switch>
            <Redirect exact to='/404' />
          </Switch>}

        <BodyClassName className='page--dealers' />
        <p tabIndex="0" className='content-headline'>{CONSTANTS.LABELS.multislots_select_slot}</p>
        <div className='map_page--details'>

          {isHappuHoureMessageEnabled && <HappyHoureTitle />}
          <div className='dealers-listing'>
            <div className='dealers-block-container'>
              {!this.state.isLoading && this.state.selectedData && this.state.selectedData.map(function (item, key) {
                return (<DealerBlock
                  dealerMouseOver={this.dealerIsHover}
                  dealerMouseOut={this.markerNotHover}
                  dealerName={item.Name}
                  dealerID={item.DealerId}
                  dealerGeoId={item.GeoId}
                  dealerAdress={item.Address}
                  SelfReception={item.SelfReception}
                  dealerCity={item.City}
                  dealerZipCode={item.ZipCode}
                  dealerPremServices={item.ListeIdSP}
                  listPremiumServices={this.props.store.listPremiumServices}
                  dealerLCV={item.LCV}
                  dealerPC={item.PC}
                  position={{ lat: Number(item.Latitude), lng: Number(item.Longitude) }}
                  isPageSolo={true}
                  key={item.DealerId}
                  dealerOpen={(this.state.pagination === 1)}
                  ref={'id' + item.DealerId}
                />)
              }.bind(this)
              )}
              {this.state.isLoading && <DealerBlockLoader />}

              {(window.siteConfig.ActivateMOREDEALERSbtn == true) &&
                !this.props.store.isEditMode &&
                <ShowMoreButton onClick={this.showMore} />}
            </div>
          </div>

        </div>
      </div>
    )
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageSolo))
